var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('header',[_c('Logo')],1),_c('section',[_c('div',{staticClass:"notfound"},[_c('img',{attrs:{"src":require('../assets/notfound.svg')}}),_c('h1',[_vm._v("Error 404")]),_c('h2',[_vm._v("Página não encontrada.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Voltar ao Inicio")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }